"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
var react_1 = __importDefault(require("react"));
var Notificacao_1 = require("../Notificacao/Notificacao");
var Icone_1 = require("../Icone/Icone");
var estiloAvatar = require("./Avatar.module.scss");
var Avatar = function (_a) {
    var alt = _a.alt, icone = _a.icone, src = _a.src, tamanho = _a.tamanho, tipo = _a.tipo, _b = _a.showNotificacao, showNotificacao = _b === void 0 ? false : _b, notificacao = _a.notificacao;
    var tamanhos = estiloAvatar[tamanho] || "";
    var tipos = estiloAvatar[tipo] || "";
    var icon = (react_1.default.createElement("div", { className: estiloAvatar.iconeRenderizado }, icone === "storefront" ? (react_1.default.createElement(Icone_1.Icone, { nome: "storefront" })) : (react_1.default.createElement(Icone_1.Icone, { nome: "person" }))));
    var imagemCliente = src ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("img", { src: src, alt: alt || "Imagem do cliente" }),
        showNotificacao && notificacao && react_1.default.createElement(Notificacao_1.Notificacao, __assign({}, notificacao)))) : (react_1.default.createElement(react_1.default.Fragment, null,
        icon,
        showNotificacao && notificacao && react_1.default.createElement(Notificacao_1.Notificacao, __assign({}, notificacao))));
    return react_1.default.createElement("div", { className: "conteudo ".concat(tamanhos, " ").concat(tipos) }, imagemCliente);
};
exports.Avatar = Avatar;
